import React from 'react';
import ArrayFieldSection from './ArrayFieldSection';

const formatDate = (dateStr) => {
  if (!dateStr) return ""; // allow user to input new one if empty
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return ""; // safely skip invalid dates
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split("T")[0];
};


const EditFieldRenderer = ({
  field,
  formData,
  handleInputChange,
  handleDropdownChange,
  handleArrayChange,
  handleAddItem,
  handleRemoveItem,
  dropdownData,
}) => {
  const rawValue = formData[field.fields] || "";
  const value =
    field.type === "date" && rawValue
      ? formatDate(rawValue)
      : rawValue;

      if (field.checkBox || field.subfields) {
        return (
          <ArrayFieldSection
            field={field}
            formData={formData}
            handleArrayChange={handleArrayChange}
            handleAddItem={handleAddItem}
            handleRemoveItem={handleRemoveItem}
            dropdownData={dropdownData}
          />
        );
      }
      const values = Array.isArray(formData[field.fields]) ? formData[field.fields] : [];


  return (
    <div className="form-group">
      <label className="form-label">{field.fields}</label>

      {field.api && field.type === 'ObjectId' ? (
        <select
          className="form-select"
          name={field.fields}
          value={value}
          onChange={handleDropdownChange}
          
        >
          <option value="">Select {field.fields}</option>
          {dropdownData[field.fields]?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>

      ) : field.options ? (
        <select
          className="form-select"
          name={field.fields}
          value={value}
          onChange={handleInputChange}
          
        >
          <option value="">Select {field.fields}</option>
          {field.options.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))}
        </select>

      ) : field.type === 'number' ? (
        <input
          className="form-input"
          type="number"
          name={field.fields}
          value={value}
          onChange={(e) => {
            const newValue = e.target.value;
            if (/^\d*$/.test(newValue)) {
              handleInputChange(e);
            }
          }}
          
        />

      ) : field.type === 'date' ? (
        <input
          className="form-input"
          type="date"
          name={field.fields}
          value={value}
          onChange={handleInputChange}
          
        />

      ) : (
        <input
          className="form-input"
          type="text"
          name={field.fields}
          value={value}
          onChange={handleInputChange}
          
        />
      )}
    </div>
  );
};

export default EditFieldRenderer;
